import { render, staticRenderFns } from "./productspec.vue?vue&type=template&id=5a7a0475&scoped=true&"
import script from "./productspec.vue?vue&type=script&lang=js&"
export * from "./productspec.vue?vue&type=script&lang=js&"
import style0 from "./productspec.vue?vue&type=style&index=0&id=5a7a0475&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7a0475",
  null
  
)

export default component.exports